<template>
    <div>
        <base-header type="gradient-primary" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 col-md-4">
                    <user-card :photoURL=photoURL :displayName=displayName :userTitle=userTitle />
                    <br>
                    <owner-tools-card  v-if="curOrg.id == null && isOwner"/>
                    <social-proof-card v-show="curOrg.id != null"/>
                </div>
                <div class="col-xl-8 col-md-8">
                    <explainer-card v-if="!pendingOrg && (!notStarted || isOwner)"/>
                    <br v-if="!notStarted || isOwner"/>
                    <pending-organizations-card v-if="isOwner" v-show="curOrg.id == null" />
                    <waiting-response-card :pendingOrg=pendingOrg v-if="pendingOrg  && !isOwner" v-show="curOrg.id == null" />
                    <get-started v-else-if="notStarted && !isOwner"/>
                    <pending-users-card v-else-if="hasRoles(['enrollUser', 'roleRead', 'roleChange', 'userUpdate'])" v-show="curOrg.id != null" />
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-xl-4 col-md-4">
                    
                </div>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>
<script>
import firebase from '@/config/firebase.js';

import GetStartedCard from '@/views/dashboard/components/GetStartedCard.vue'
import WatingResponseCard from '@/views/dashboard/components/WaitingResponseCard.vue'
import PendingUsersCard from '@/views/dashboard/components/PendingUsersCard.vue'
import PendingOrganizationsCard from '@/views/dashboard/components/PendingOrganizationsCard.vue'
import UserCard from '@/views/dashboard/components/UserCard.vue'
import OwnerToolsCard from '@/views/dashboard/components/OwnerToolsCard.vue'
import SocialProofCard from '@/views/dashboard/components/SocialProofCard.vue'
import ExplainerCard from '@/views/dashboard/components/ExplainerCard.vue'


export default {
    components: {
        'get-started': GetStartedCard,
        'waiting-response-card': WatingResponseCard,
        'user-card': UserCard,
        'pending-users-card': PendingUsersCard,
        'pending-organizations-card': PendingOrganizationsCard,
        'owner-tools-card': OwnerToolsCard,
        'explainer-card': ExplainerCard,
        'social-proof-card': SocialProofCard
    },
    data() {
        return {
            email: '',
            displayName: '',
            photoURL: '',
            userTitle: '',
            notStarted: false,
            pendingOrg: null,
        };
    },
    computed: {
        curOrg () {
            return this.$store.state.usermain.curOrg;
        },
        currentUser () {
            return this.$store.state.usermain.currentUser;
        },
        isOwner () {
            return this.$store.state.usermain.isOwner;
        },
        rolesData () {
            return this.$store.state.usermain.rolesData;
        }
    },
    watch: {
        isOwner (newIsOwner, _) {
            if (newIsOwner) {
                this.userTitle = "Owner";
            }
        },
    },
    methods: {
        hasRoles: function (roles) {
            return roles.every(this.hasRole);
        },
        hasRole: function (role) {
            return this.rolesData[role] != null || this.isOwner
        },
        userData: function () {
            const user = firebase.auth().currentUser;

            this.email = user.email;
            this.displayName = user.displayName;
            this.photoURL = user.photoURL;

            this.checkUserData(user);
        },
        checkUserData: function (user) {
            const self = this;

            var userRef = firebase.firestore().collection("users").doc(user.uid);
            
            userRef.get().then(function (userDoc) {
                if (!userDoc.exists) {
                    self.notStarted = true;
                } else {
                    const userData = userDoc.data();

                    if (userData.orgId) {
                        firebase.firestore().doc("organizations/" + userData.orgId).get().then(function (orgDoc) {
                            const orgData = orgDoc.data();

                            self.userTitle = 'User in ' + orgData.name;
                        });
                    }
 
                    if (userData.pendingOrg) {
                        firebase.firestore().doc("organizations/" + userData.pendingOrg).get().then(function (orgDoc) {
                            self.pendingOrg = orgDoc.data();
                        });
                    }
                    if(userData.pendingNewOrg) {
                        firebase.firestore().doc("pendingOrganizations/" + userData.pendingNewOrg).get().then(function (orgDoc) {
                            self.pendingOrg = orgDoc.data();
                        });
                    }
                }
            });
        },
    },
    mounted() {
        this.userData();
    }
};
</script>
<style></style>
